export default __webpack_public_path__ + "img/fb726b200fe285f798b9887581745688.mp3";